import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-footer',
  standalone: false,
  templateUrl: './footer.html',
  styleUrl: './footer.scss'
})
export class Footer {
  constructor(private router: Router) {}


  goToCourses() {
  this.router.navigate(['/'], { fragment: 'video-learning' })
    .then(() => {
      setTimeout(() => {
        document
          .getElementById('video-learning')
          ?.scrollIntoView({ behavior: 'smooth' });
      }, 300);
    });
}
}
